import { render, staticRenderFns } from "./PreliquidationGeneration.vue?vue&type=template&id=63211aea"
import script from "./PreliquidationGeneration.vue?vue&type=script&lang=js"
export * from "./PreliquidationGeneration.vue?vue&type=script&lang=js"
import style0 from "./PreliquidationGeneration.vue?vue&type=style&index=0&id=63211aea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports